import { Injectable } from '@angular/core';
import { Config } from '../models/config';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MemberSubscrpitionHistoryService {

  constructor(private http: HttpClient) { }

  getMemberSubscriptionHistoriesForMemberUser(): any {
    return this.http.get(`${Config.apiUrl}/MemberSubscrpitionHistory/GetMemberSubscriptionHistoriesForMemberUser`);
  }
  reNewSubscription(model): any {
    return this.http.post(`${Config.apiUrl}/MemberSubscrpitionHistory/ReNewSubscription` , model);
  }
}
